import config from '@config';
import router from '@router';
import store from '@store';
import utils from 'blue-utils';
import { Base64 } from 'js-base64';
import { $toast } from '$use-in-vue/mint-ui/toast/index'

//分享的url可能是动态需要的配置，可以为String或者Function
export function shareLink(opts = {}) {
  const shareOrigin = (config.share.origin || config.path.base) + (opts._mode == 'router' ? '/common/autoreg' : '');
  if(opts.link){
    const link = opts.link || config.share.link || router.getHref();
    if(utils.isStr(link)){
      return `${shareOrigin}?${shareLinkParams(link)}`;
    }else if(utils.isFunction(link)){
//      let bb = link.bind(this);
//      console.log(bb)
      let aalink = shareLinkParams(utils.hook(null, link));
      return `${shareOrigin}?${shareLinkParams()}`;
    }
  }else{
    //分享的域名配置
    //  带上/common/autoreg  修改微信分享经过授权跳首页的bug
    return `${shareOrigin}?${shareLinkParams()}`;
  }

}

//扩展分享链接参数
function shareLinkParams(link) {
  const share = config.share;
  const shareParams = share.params;
  //用户手机号
  const phone = store.state.userInfo.phone;
  //默认分享地址上带的参数
  const defaultParams = {
    url_type:8
  };

  const fullPath = (() => {
    const mode = router.mode;
    if (mode === 'history') {
      return router.currentRoute.fullPath;
    } else if (mode === 'hash') {
      return `/#${router.currentRoute.fullPath}`;
    }
  })();


  if(link){
    const origin = link.split('?')[0];
    //路径中的query
    const linkQuery = utils.parseParams(utils.getLinkParams(link));
    if(link.indexOf('#') == -1){
      link = config.path.indexPath + '/#' + link
    };
    let link_split = link.split('#');
    let wantUrl = link_split[0] || config.path.indexPath;
    let redirectUrl = `/#${link_split[1]}` || fullPath;
    let _params = {
      [shareParams.phone]: phone ? Base64.encode(phone) : '',
        ...defaultParams,
      [shareParams.redirectUrl]: redirectUrl,
      [shareParams.wantUrl]: `${wantUrl}`     //业务需要，添加跳转链接
    }

    return utils.stringifyParams(_params)
  }

  const params = {
    [shareParams.phone]: phone ? Base64.encode(phone) : '',
      ...defaultParams,
    [shareParams.redirectUrl]: `${fullPath}`,
    [shareParams.wantUrl]: `${config.path.indexPath}`     //业务需要，添加跳转链接
  };
  return utils.stringifyParams(params);

}

//公共的分享 app 分享 || 普通浏览器和微信提示分享操作
export function share(opts) {
  const device = config.device;
  const shareConfig = config.share;
  //webview分享
  if (config.device.isApp) {
    try {
      dtb.iPhoneShare(JSON.stringify({
        title: opts.title || shareConfig.title,
        descr: opts.descr || shareConfig.deps,
        thumImage: opts.thumImage || shareConfig.imgUrl,
        shareUrl: shareLink({
          link: opts.shareUrl,
          _mode: opts._mode
        })
      }));
    } catch (e) {
      console.warn(`share error:`, e);
    }
  } else if (device.isWeChat) {// 微信端
    $toast({
      message: '点击右上角“...”分享按钮进行转发'
    });
  } else if (device.isWap) {  // app端
    $toast({
      message: '请通过浏览器自带分享功能进行转发'
    });
  }

}